module.exports = __webpack_public_path__ + "img/box.36dca015.jpg";